import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';
import { Condition } from '@zipari/shared-ds-util-form';
import { ModelAttributeItemAlignment } from '../model-attribute-grid/model-attribute-grid.constants';

export class ModelAttributeGridListConfig {
  label?: string;
  canEdit?: boolean;
  canDelete?: boolean;
  editConditions?: ActionCondition;
  deleteConditions?: ActionCondition;
  itemLabel?: string;
  attributes?: ModelAttributeConfig[];
  alignItems?: ModelAttributeItemAlignment = ModelAttributeItemAlignment.left;
  columns?: number;
}

export class ActionCondition {
  conditions: Condition;
}
